import React from 'react';
import { FindStores } from '@thisisdevelopment/akzonobel-core';
import { ContainerInner, Page } from '@thisisdevelopment/heritage-core-library';
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';

function Stores() {
  const meta = metas.stores;
  return (
    <div>
      <NextHead meta={meta} />
      <Page title="Find a Store">
        <ContainerInner mb="60px">
          <FindStores
            title="Find a store that stocks Heritage"
            headline="In the coming weeks we will be updating this page with more stockists as we continue our product rollout."
            initialZoom={6}
            initialCenter={{ lat: 54.5437, lng: -4.3601 }}
          />
        </ContainerInner>
      </Page>
    </div>
  );
}

export default Stores;
